import { type ViewerProps, type ViewerState, Viewer as ViewerBase } from '@seddi/ui-three-viewer';
import log from 'loglevel';
import type { FC } from 'react';
import styled from 'styled-components';

import { useAppViewer } from './AppViewer.hooks';
import { AppViewerTool } from './appViewerTool';

import cameraImage from './camera.svg';

export class Viewer extends ViewerBase<ViewerProps, ViewerState> {
  componentDidMount() {
    super.componentDidMount();
    log.info('Scene is loading');
    // Remove camera parent transform node (Author legacy).
    const { camera } = this;
    camera.parent = null;
    // Init camera tool.
    const canvas = this.canvasRef.current!;
    this.tool = new AppViewerTool({ camera, canvas });
  }
}

const Container = styled.div<{ $height: string; $width: string }>`
  background-color: #e5e5f7;
  background-image:
    repeating-linear-gradient(
      45deg,
      #999999 25%,
      transparent 25%,
      transparent 75%,
      #999999 75%,
      #999999
    ),
    repeating-linear-gradient(45deg, #999999 25%, #e5e5f7 25%, #e5e5f7 75%, #999999 75%, #999999);
  background-position:
    0 0,
    20px 20px;
  background-size: 40px 40px;
  display: block;
  height: ${({ $height }) => $height};
  position: relative;
  width: ${({ $width }) => $width};
`;

const CaptureButton = styled.button`
  border-radius: 4px;
  left: 0;
  position: absolute;
  top: 0;
`;

const CaptureImage = styled.img`
  height: 39px;
  width: 32px;
`;

export const AppViewer: FC = () => {
  const {
    config,
    featureFlags,
    handleDownloadImage,
    handleUpdate,
    resolution,
    scene,
    viewerRef,
    visible,
  } = useAppViewer();

  return (
    <Container $height={`${resolution.y}px`} $width={`${resolution.x}px`}>
      {scene && (
        <>
          <Viewer
            backgroundAlpha={0}
            backgroundColor="#000000"
            config={config}
            featureFlags={featureFlags}
            id="canvas"
            onUpdate={handleUpdate}
            preserveDrawingBuffer={true}
            ref={viewerRef}
            scene={scene}
            showGarmentGeometry={true}
            visible={visible}
          />
          <CaptureButton onClick={handleDownloadImage}>
            <CaptureImage src={cameraImage} />
          </CaptureButton>
        </>
      )}
    </Container>
  );
};
